import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {
  AppointmentAvailability,
  AppointmentDayAvailability,
  AppointmentEntryConfigResponse,
  AppointmentPreselection,
  AppointmentSlot,
  BookingConfirmation,
  ConsentState,
  PatientDetails,
  SmsMetaResponse,
  SmsSendResponse,
  SmsVerifyResponse
} from '../model/appointments-models';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppointmentsApiService {
  private readonly baseUrl = `${environment.appointmentsApiURL}/api/v1`;

  constructor(private http: HttpClient) {}

  getEntryConfig(): Observable<AppointmentEntryConfigResponse> {
    return this.http.get<AppointmentEntryConfigResponse>(
      `${this.baseUrl}/entry-config`,
      {withCredentials: true}
    );
  }

  getAvailability(preselection: AppointmentPreselection): Observable<AppointmentAvailability> {
    return this.http.post<AppointmentAvailability>(
      `${this.baseUrl}/availability/search`,
      {
        insurance: preselection.insurance,
        appointmentType: preselection.appointmentType,
        patientStatus: preselection.patientStatus
      },
      {withCredentials: true}
    );
  }

  submitPatientDetails(
    preselection: AppointmentPreselection,
    selectedDay: AppointmentDayAvailability,
    selectedSlot: AppointmentSlot,
    details: PatientDetails,
    consents: ConsentState
  ): Observable<void> {
    return this.http.post<void>(
      `${this.baseUrl}/patient-details`,
      {
        insurance: preselection.insurance,
        appointmentType: preselection.appointmentType,
        patientStatus: preselection.patientStatus,
        slot: {
          date: selectedDay.date,
          slotId: selectedSlot.id
        },
        patientDetails: details,
        consents
      },
      {withCredentials: true}
    );
  }

  sendSmsCode(): Observable<SmsSendResponse> {
    return this.http.post<SmsSendResponse>(
      `${this.baseUrl}/sms/send`,
      null,
      {withCredentials: true}
    );
  }

  getSmsMeta(): Observable<SmsMetaResponse> {
    return this.http.get<SmsMetaResponse>(
      `${this.baseUrl}/sms/meta`,
      {withCredentials: true}
    );
  }

  verifySmsCode(code: string): Observable<SmsVerifyResponse> {
    return this.http.post<SmsVerifyResponse>(
      `${this.baseUrl}/sms/verify`,
      {code},
      {withCredentials: true}
    );
  }

  confirmBooking(): Observable<BookingConfirmation> {
    return this.http.post<BookingConfirmation>(
      `${this.baseUrl}/booking/confirm`,
      null,
      {withCredentials: true}
    );
  }
}
